export const ROUTING_NUMBER = "bankRouting";
export const ACCOUNT_NUMBER = "bankAccount";
export const PAYMENT_TERMS = "paymentTerm";
export const PAYMENT_METHOD = "paymentMethodId";
export const TAX_CODE = "taxJurisdictionCode";
export const TAX_ID = "taxId";
export const STATE_TAX_ID = "stateTaxId";
export const CURRENT_BALANCE = "currentBalance";
export const PREVIOUS_BALANCE = "preYearBalance";
export const ZELLE_PHONE = "zellePhone";
export const ZELLE_EMAIL = "zelleEmail";
export const VENDOR_ID = "vendorId";
